module.exports = __webpack_public_path__ + "static/satellite-0e72750d875309d46e0fc91b9c28debd.svg";